export const THERAPY_TEXT_MIN_LENGTH = 4;

export const EMPTY_THERAPY_VALUES = {
  provider_name: '',
  service_type: '',
  phone_number: '',
  email: '',
  start_date: null,
  end_date: null,
  hours: '',
  frequency: '',
  progress: '',
  do_not_share_info_with_provider: false,
  is_record_shared: '',
} as const;

export const THERAPY_SERVICE_TYPE_OPTIONS = [
  { value: 'Applied Behavior Analysis (ABA)', label: 'Applied Behavior Analysis (ABA)' },
  { value: 'Speech Therapy', label: 'Speech Therapy' },
  { value: 'Occupational Therapy', label: 'Occupational Therapy' },
  { value: 'Physical Therapy', label: 'Physical Therapy' },
  { value: 'Counseling Services', label: 'Counseling Services' },
  { value: 'Feeding Therapy', label: 'Feeding Therapy' },
  { value: 'Equestrian Therapy', label: 'Equestrian Therapy' },
  { value: 'Other', label: 'Other' },
] as const;

export const THERAPY_FREQUENCY_OPTIONS = [
  { value: 'Daily', label: 'Daily' },
  { value: 'Weekly', label: 'Weekly' },
  { value: 'Semi-weekly', label: 'Semi-weekly' },
  { value: 'Monthly', label: 'Monthly' },
  { value: 'Semi-monthly', label: 'Semi-monthly' },
] as const;

export const THERAPY_PROGRESS_OPTIONS = [
  { value: 'Positive improvement', label: 'Positive improvement' },
  { value: 'No progress', label: 'No progress' },
  { value: 'Unfavorable outcome', label: 'Unfavorable outcome' },
] as const;

export const THERAPY_RECORD_SHARED_OPTIONS = [
  { value: 'Shared', label: 'Shared' },
  { value: 'Will share', label: 'Will share' },
] as const;
